var ProductAnalyticsLogger = {}

ProductAnalyticsLogger.Level = {
  SILENT: 6,
  ERROR: 5,
  WARNING: 4,
  NOTICE: 3,
  DEBUG: 2,
  VERBOSE: 1
}

ProductAnalyticsLogger.logLevel = 5

ProductAnalyticsLogger.warn = function () {
  ProductAnalyticsLogger._log([].slice.call(arguments), console.warn, ProductAnalyticsLogger.Level.WARNING, 'lightorange', 'w')
}

ProductAnalyticsLogger.notice = function () {
  ProductAnalyticsLogger._log([].slice.call(arguments), console.log, ProductAnalyticsLogger.Level.NOTICE, 'lightgreen', 'n')
}

ProductAnalyticsLogger._log = function (msg, method, level, color, letter) {
  if (ProductAnalyticsLogger.logLevel <= level) {
    var d = new Date()
    var hh = ('0' + d.getDate()).slice(-2)
    var mm = ('0' + d.getMinutes()).slice(-2)
    var ss = ('0' + d.getSeconds()).slice(-2)
    var mmm = ('00' + d.getMilliseconds()).slice(-3)
    var currentTime = '[' + hh + ':' + mm + ':' + ss + '.' + mmm + ']'

    var prefix = '%c[Youbora Product Analytics]' + currentTime + ' ' + letter + ':'

    if (Array.isArray(msg)) {
      msg.splice(0, 0, prefix, 'color: ' + color)
      method.apply(console, msg)
    } else {
      method.call(console, prefix, 'color: ' + color, msg)
    }
  }
}

module.exports = ProductAnalyticsLogger
